function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.05752 4.99989L9.28252 1.78239V1.78239C9.57661 1.4883 9.57661 1.01148 9.28252 0.717395C8.98842 0.423303 8.51161 0.423303 8.21752 0.717395L5.00002 3.94239L1.78252 0.717395L1.78252 0.717395C1.48842 0.423303 1.01161 0.423303 0.717515 0.717395C0.423424 1.01149 0.423424 1.4883 0.717515 1.78239V1.78239L3.94252 4.99989L0.717515 8.21739V8.21739C0.423424 8.50908 0.421477 8.98395 0.713166 9.27804C0.71461 9.2795 0.71606 9.28095 0.717515 9.28239H0.717515C1.00921 9.57648 1.48408 9.57843 1.77817 9.28674C1.77962 9.2853 1.78107 9.28385 1.78251 9.28239L5.00001 6.05739L8.21751 9.28239V9.28239C8.5092 9.57648 8.98407 9.57843 9.27816 9.28674C9.27962 9.2853 9.28107 9.28385 9.28251 9.28239V9.28239C9.5766 8.9907 9.57855 8.51583 9.28686 8.22174C9.28542 8.22029 9.28397 8.21884 9.28251 8.21739L6.05752 4.99989Z",
  fill: "#1E5CF4"
});

var SvgCrossItxChromeExtension = function SvgCrossItxChromeExtension(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossItxChromeExtension, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross-itx-chrome-extension.8c359f30.svg";
export { ForwardRef as ReactComponent };